$(document).ready(function () {
      $(".second-lvl-hamburger div:first").addClass("active focus-inset");
      $(".second-lvl-hamburger div").click(function () {
          var targetId = $(this).attr("id");
          var targetMenu = $(".third-lvl-hamburger #" + targetId);
          if (targetMenu.length) {
              var container = $(".third-lvl-hamburger");
              container.children().hide();
              targetMenu.show();
              $(".second-lvl-hamburger div").removeClass("active focus-inset");
              $(this).addClass("active focus-inset");
              $(".third-lvl-hamburger div").removeClass("active");
              targetMenu.addClass("active");
          }
      });

      $(".second-lvl-hamburger summary").click(function () {
          $(".second-lvl-hamburger summary").removeClass("active focus-inset");
          $(this).addClass("active focus-inset");
      });
  });

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".first-lvl-menu").forEach(function (menuItem) {
        menuItem.addEventListener("click", function (e) {
            let submenu = this.parentElement.querySelector(".second-lvl-menu");
            if (submenu) {
                submenu.classList.add("active");
                this.classList.add("active");
            }
        });
    });

    document.querySelectorAll(".menu-drawer__close-buttonss").forEach(function (closeBtn) {
        closeBtn.addEventListener("click", function () {
            let secondLvlMenu = this.closest(".second-lvl-menu");
            if (secondLvlMenu) {
                secondLvlMenu.classList.remove("active");
            }
            document.querySelectorAll(".first-lvl-menu.active").forEach(function (menuItem) {
                menuItem.classList.remove("active");
            });
        });
    });
  });
document.addEventListener("DOMContentLoaded", function () {
  const isKwikpassLogin = sessionStorage.getItem("isKwikpassLogin") === "true";

  const loginSection = document.querySelector(".customerHeaderLogin");
  const logoutSection = document.querySelector(".customerHeaderLogout");

  if (isKwikpassLogin) {
    if (loginSection) {
      loginSection.classList.add("loginHidden");
      loginSection.classList.remove("loginVisible");
    }
    if (logoutSection) {
      logoutSection.classList.remove("loginHidden");
      logoutSection.classList.add("loginVisible");
    }
  } else {
    if (loginSection) {
      loginSection.classList.remove("loginHidden");
      loginSection.classList.add("loginVisible");
    }
    if (logoutSection) {
      logoutSection.classList.add("loginHidden");
      logoutSection.classList.remove("loginVisible");
    }
  }
});

